import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Layout, Menu, Button, Avatar, Typography, Spin, message } from "antd";
import {
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate, Link, Outlet } from "react-router-dom";

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

const UserLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useSelector((state) => state.auth);

  const [collapsed, setCollapsed] = useState(false);
  const [name, setName] = useState("User");
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {

    if (!auth?.token) {
      message.destroy();
      message.error("Not Authenticated! Please login.");
      navigate("/");
    } else if (auth?.role !== "ROLE_HR") {
      message.destroy();
      message.error("You are not authorized to access this page.");
    } else {
      setName(auth?.name || "User");
      setIsAuthorized(true);
    }
  }, [auth, navigate]);

  useEffect(() => {
    const handleResize = () => {
      setCollapsed(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuItems = [
    {
      key: "/analyze_resumes",
      label: "Analyze Resumes",
      path: `/cvanalyzer`,
      icon: <FileSearchOutlined />,
    },
  ];


  if (!isAuthorized) {
    return (
      <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <h1>User Not Authorized</h1>
      </div>
    );
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        theme="dark"
        width={220}
        style={{
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
          height: "100vh",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            height: 64,
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
            fontSize: 20,
            fontWeight: "bold",
            color: "#fff",
            marginLeft: 10,
          }}
        >
          {!collapsed && (
            <>
              <span>CV</span>
              <span style={{ color: "#E84C66", marginLeft: 4 }}>Analyzer</span>
            </>
          )}
        </div>

        <Menu theme="dark" selectedKeys={[location.pathname]} mode="inline">
          {menuItems.map((item) => (
            <Menu.Item key={item.path} icon={item.icon}>
              <Link to={item.path}>{item.label}</Link>
            </Menu.Item>
          ))}
        </Menu>
      </Sider>

      <Layout style={{ marginLeft: collapsed ? 80 : 220, transition: "margin-left 0.2s" }}>
        <Header
          style={{
            background: "#001529",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 24px",
            color: "#fff",
            transition: 'left 0.2s',
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px"
            }}
          >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ color: "#fff" }}
          />

          <div style={{ fontSize: 20, fontWeight: "bold" }}>
            Welcome <span style={{ color: "#E84C66" }}>{name}</span>
          </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <Button
              type="primary"
              style={{
                backgroundColor: "#E84C66",
                borderColor: "#E84C66",
                fontWeight: "500",
                height: "35px",
                padding: "0 16px",
                whiteSpace: "nowrap",
              }}
              onClick={() => window.location.href = "/dashboardHr"}
            >
              Go to Resume Builder
            </Button>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                gap: 8,
              }}
            >
              <Avatar icon={<UserOutlined />} />
              <Text style={{ color: "white" }}>{name}</Text>
            </div>
          </div>
        </Header>

        <Content style={{ margin: 16, padding: 24, background: "#fff" }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default UserLayout;
